export default __webpack_public_path__ + "static/media/uploadIcon.87846948.svg";